import React from 'react'
import { DetailsRow } from '../DetailsRow'
import { DetailsColumn } from '../DetailsColumn'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { FieldsRow } from '../FieldsRow'
import { CountryReadOnlyField } from 'components/Shared/CountryReadOnlyField/CountryReadOnlyField'
import Sections from 'components/Order/sections'

export function CustomIntermediatePointDetails ({ customIntermediatePoint, diffValues }) {
  return (
    <DetailsRow section={Sections.Custom}>
      <DetailsColumn>
        <ReadOnlyTextField value={customIntermediatePoint.address.address}
                           label="order.details.customIntermediatePoint.fields.address"
                           previousValue={diffValues && { value: diffValues.address.address }}
        />
        <ReadOnlyTextField value={customIntermediatePoint.address.city}
                           label="order.details.customIntermediatePoint.fields.city"
                           previousValue={diffValues && { value: diffValues.address.city }}
        />
        <FieldsRow>
          <CountryReadOnlyField
            value={customIntermediatePoint.address.countryCode}
            label="order.details.customIntermediatePoint.fields.country"
            previousValue={diffValues && { value: diffValues.address.countryCode }}
          />
          <ReadOnlyTextField value={customIntermediatePoint.address.zipCode}
                             label="order.details.customIntermediatePoint.fields.zipCode"
                             previousValue={diffValues && { value: diffValues.address.zipCode }}
          />
        </FieldsRow>
      </DetailsColumn>
      <DetailsColumn>
        <ReadOnlyTextField value={customIntermediatePoint.description}
                           label='order.details.customIntermediatePoint.fields.description'
                           multiline
                           rows={5}
                           previousValue={diffValues && { value: diffValues.description }}
        />
      </DetailsColumn>
    </DetailsRow>
  )
}
